import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Input } from './ui/input';
import { Button } from './ui/button';
import { Mail, Info } from 'lucide-react';
import BrandLogo from './BrandLogo';
import { GoogleIcon, AppleIcon, GitHubIcon, FacebookIcon } from './BrandIcons';
import { toast } from '../hooks/use-toast';

export default function AuthDialog({ open, onOpenChange }) {
  const [email, setEmail] = useState('');

  const startGoogleAuth = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/build';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const showComingSoon = (provider) => {
    toast({
      title: `${provider} sign-in coming soon`,
      description: 'For now, please sign in with Google.',
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[440px] rounded-2xl border-slate-200">
        <DialogHeader>
          <div className="flex justify-center mb-3">
            <BrandLogo size={40} tone="dark" />
          </div>
          <DialogTitle className="text-2xl font-semibold text-center">
            Welcome
          </DialogTitle>
          <p className="text-center text-sm text-slate-500 mt-1">
            Sign in with Google to open your builder workspace. Free to start.
          </p>
        </DialogHeader>

        <div className="grid gap-3 mt-3">
          <Button
            onClick={startGoogleAuth}
            className="h-11 rounded-xl bg-white hover:bg-slate-50 text-slate-900 border border-slate-200 justify-center font-medium shadow-sm"
          >
            <GoogleIcon size={18} className="mr-2" />
            Continue with Google
          </Button>

          <div className="grid grid-cols-3 gap-3">
            <Button variant="outline" onClick={() => showComingSoon('GitHub')} className="h-11 rounded-xl bg-slate-900 hover:bg-slate-800 text-white border-slate-900">
              <GitHubIcon size={18} />
            </Button>
            <Button variant="outline" onClick={() => showComingSoon('Apple')} className="h-11 rounded-xl bg-slate-900 hover:bg-slate-800 text-white border-slate-900">
              <AppleIcon size={18} />
            </Button>
            <Button variant="outline" onClick={() => showComingSoon('Facebook')} className="h-11 rounded-xl bg-white hover:bg-slate-50 border-slate-200">
              <FacebookIcon size={20} />
            </Button>
          </div>

          <div className="flex items-center gap-3 my-1">
            <div className="h-px flex-1 bg-slate-200" />
            <span className="text-xs text-slate-400 tracking-widest">OR</span>
            <div className="h-px flex-1 bg-slate-200" />
          </div>

          <div className="relative">
            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input
              type="email"
              placeholder="you@company.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="pl-10 h-11 rounded-xl"
              disabled
            />
          </div>
          <Button disabled className="h-11 rounded-xl bg-slate-100 text-slate-500 cursor-not-allowed">
            Email sign-in coming soon
          </Button>

          <div className="flex items-start gap-2 text-[11px] text-slate-500 mt-2 px-1">
            <Info size={12} className="mt-0.5 shrink-0" />
            <span>
              By continuing, you agree to our Terms of Service and Privacy Policy.
              Your Google account is used only to identify you &mdash; we never
              post on your behalf.
            </span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
